module.exports = __webpack_public_path__ + "static/media/eade.a6d7c075.png";